import React, { useEffect, useState } from "react";
import { Button } from "semantic-ui-react";

export const SeleccionarNota = ({ nombre, nuevoValue, updateValue }) => {
  const [valor, setValor] = useState(null);

  const cambioNota = (nota) => {
    updateValue(nombre, nota);
    setValor(nota);
  };

  useEffect(() => {
    if (valor === null) {
      console.log("Notas es null " + nuevoValue);
      setValor(nuevoValue);
    }
  }, [nuevoValue]);

  return (
    <Button.Group>
      <Button
        onClick={() => cambioNota(1)}
        color={valor == 1 ? "violet" : "grey"}
      >
        1
      </Button>
      <Button onClick={() => cambioNota(2)} color={valor == 2 ? "red" : "grey"}>
        2
      </Button>
      <Button
        onClick={() => cambioNota(3)}
        color={valor == 3 ? "orange" : "grey"}
      >
        3
      </Button>
      <Button
        onClick={() => cambioNota(4)}
        color={valor == 4 ? "yellow" : "grey"}
      >
        4
      </Button>
      <Button
        onClick={() => cambioNota(5)}
        color={valor == 5 ? "olive" : "grey"}
      >
        5
      </Button>
      <Button
        onClick={() => cambioNota(6)}
        color={valor == 6 ? "green" : "grey"}
      >
        6
      </Button>
      <Button
        onClick={() => cambioNota(7)}
        color={valor == 7 ? "teal" : "grey"}
      >
        7
      </Button>
    </Button.Group>
  );
};
